import { dialogUtil } from './dialog'
import { toastUtil } from './toast'
import { isApp } from './platform'

/**
 * 위치 권한이 거부됐을 때 켜는 길을 안내한다.
 *
 * 왜 필요한가
 * ----------
 * iOS는 위치를 한 번 거부하면 그 뒤로 권한 팝업을 띄워주지 않는다. 앱이 다시
 * 요청해도 조용히 실패한다. 그래서 지금까지는 '위치 권한을 허용해주세요'
 * 토스트만 뜨고 끝났는데, 시키는 대로 눌러도 허용할 방법이 없는 상태였다.
 *
 * 설정 앱의 이 앱 페이지에 위치 토글이 있다. 거기로 보내는 것이 유일한 통로다.
 *
 * 여는 곳은 '이 앱의 페이지'다
 * -------------------------
 * 시스템 설정 아무 데나 여는 게 아니다. 그건 비공개 스킴(prefs:root=)이라
 * 심사에서 막힌다(지침 2.5.1). 이 앱 페이지를 여는 것은 애플이 제시하는
 * 공개 API이고, permission_handler가 쓰는 것도 그것이다.
 */
export async function guideLocationPermission(): Promise<void> {
  const bridge = (window as unknown as {
    FlutterBridge?: { openAppSettings?: () => void }
  }).FlutterBridge

  // 설정을 열 수 없는 환경(웹 브라우저, 이 기능이 없는 옛 앱)에서는
  // 안내 창을 띄워봐야 갈 곳이 없다. 예전처럼 알리기만 한다.
  if (!isApp() || typeof bridge?.openAppSettings !== 'function') {
    toastUtil.error('위치 권한을 허용해주세요')
    return
  }

  // 앱의 다른 확인 창과 같은 형태로 맞춘다 — title 없이 message 한 덩어리,
  // 두 줄이 필요하면 줄바꿈. (기록 삭제·플레이트리스트 삭제 등과 동일)
  const go = await dialogUtil.confirm({
    message: '가까운 곳을 찾으려면\n위치 권한이 필요해요',
    confirmText: '설정 열기',
    cancelText: '나중에',
  })

  if (go) {
    bridge.openAppSettings()
  }
}
